import React from 'react'
import { useTranslation } from 'react-i18next'

const GOOGLE_REVIEWS_URL =
  'https://www.google.com/maps/place/Tacos+y+Pupusas+Tia+Sandra/@33.2289523,-97.1528204,16.7z/data=!4m8!3m7!1s0x864dcb91e4d7659f:0x1be34d267cc9616d!8m2!3d33.2289679!4d-97.1493577!9m1!1b1'

function Reviews() {
  const { t } = useTranslation()

  const reviews = [
    { key: 'review1', authorKey: 'review1Author' },
    { key: 'review2', authorKey: 'review2Author' },
    { key: 'review3', authorKey: 'review3Author' }
  ]

  return (
    <section id="reviews" className="section reviews" aria-labelledby="reviews-heading">
      <div className="container-wide">
        <h2 id="reviews-heading">{t('reviews.heading')}</h2>
        <p className="reviews-summary">{t('reviews.summary')}</p>

        <div className="reviews-grid">
          {reviews.map(({ key, authorKey }) => (
            <blockquote key={key} className="review-card">
              <p className="review-body">{t(`reviews.${key}`)}</p>
              <footer className="review-author">{t(`reviews.${authorKey}`)}</footer>
            </blockquote>
          ))}
        </div>

        <p className="reviews-read-more">
          <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer">
            {t('reviews.readMore')}
          </a>
        </p>
      </div>
    </section>
  )
}

export default Reviews
